import { saveLocalData, isCsairApp, getLocalData } from '@csair/emp-helpers';

function removePropertyOfNull(obj) {
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'undefined' || obj[key] === null) delete obj[key];
  });
  return obj;
}

export function saveRefundAppStore(state) {
  if (!isCsairApp()) return false;
  const { EdorsedApply } = state;
  saveLocalData(
    'EMP_STORE_CHANNEL',
    JSON.parse(window.sessionStorage.getItem('emp_channel')?window.sessionStorage.getItem('emp_channel'):null)
  );
  saveLocalData(
    'EMP_STORE_EDORSEDAPPLY',
    removePropertyOfNull({
      flightList: EdorsedApply.flightList.map(item => {
        return removePropertyOfNull(item);
      }),
      psgList: EdorsedApply.psgList.map(item => {
        return removePropertyOfNull(item);
      }),
      ticketNo: EdorsedApply.ticketNo,
      orderNo: EdorsedApply.orderNo,
      isDomestic: EdorsedApply.isDomestic,
      refundMethod: EdorsedApply.refundMethod,
      ticketClass: EdorsedApply.ticketClass,
      ticketType: EdorsedApply.ticketType,
      xProduct: {
        flightProductId: '',
        products: [],
        xSoProducts: {},
      },
    })
  );
}

export function getRefundAppStore() {
  if (!isCsairApp()) return false;
  window.sessionStorage.setItem(
    'emp_channel',
    JSON.stringify(getLocalData('EMP_STORE_CHANNEL'))
  );
  return getLocalData('EMP_STORE_EDORSEDAPPLY');
}



// WEBPACK FOOTER //
// ./src/utils/util_appRefundStore.js